export default __webpack_public_path__ + "static/media/LogoWhite.e18a1da5.png";